import React from "react"
import {Button,} from "antd";
import ViewUnit from "components/app/view/ViewUnit";
import {IViewStepProps} from "./ViewUnitForm";
import LocaleText from "../../../settings/dictionary/LocaleText";

class ViewUnitPreview extends React.Component<IViewStepProps> {
    render() {
        const {resource, match, history, view} = this.props

        return (
            <div>
                {resource && resource.type && resource.contentTypes && (
                    <ViewUnit view={view} preview={true} uuid={resource.uuid} resource={resource} match={match}
                              history={history}/>
                )}

                <Button type={"primary"} onClick={() => this.props.setStep()}><LocaleText code={'general.next-step'} fallback={'Následující krok'}/></Button>
                <Button onClick={() => this.props.setStep(true)}><LocaleText code={'general.previous-step'} fallback={'Předchozí krok'}/></Button>
            </div>
        )
    }
}

export default ViewUnitPreview